module.exports = __webpack_public_path__ + "static/img/img_media03.66b2c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/img_media03.png
// module id = duG4
// module chunks = 0